<span *ngIf="countryName" class="mx-1"> {{ countryName }} </span>
<span class="f32">
  <span class="flag {{ countryCode | lowercase }}"></span>
</span>
